import { Component } from '@angular/core';

@Component({
    selector: 'dashboard',
    templateUrl: 'dashboard.template.html'
})
export class DashboardComponent { }


// WEBPACK FOOTER //
// ./src/app/views/dashboard/dashboard.component.ts